/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import NewsletterModel from 'cio/models/newsletter';
import FormValidations from 'cio/utils/form-validations';

export interface TestSetupArgs {
  newsletter: NewsletterModel;
  errors: FormValidations['errors'];
  validate: FormValidations['validateAttribute'];
}

export default class TestSetup extends Component<TestSetupArgs> {
  constructor(owner: unknown, args: TestSetupArgs) {
    super(owner, args);
    this.args.newsletter.findRecipients();
  }
}
